import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './PaymentFailed.css';

function PaymentFailed() {
  const location = useLocation();
  const { productName, paymentAmount } = location.state || {};

  return (
    <div className="payment-failed page-shell">
      <div className="section-card">
        <span className="tag">Payment error</span>
        <h1 className="page-title">We could not complete your payment</h1>
        <p className="page-lead">
          Something went wrong while processing your payment. Please try again or contact support.
        </p>
        {productName && <p><strong>Product:</strong> {productName}</p>}
        {paymentAmount && <p><strong>Amount:</strong> ${paymentAmount}</p>}
        <div className="payment-actions">
          <Link to="/products" className="ghost-cta">Back to products</Link>
          <Link to="/contact-us" className="primary-cta">Contact support</Link>
        </div>
      </div>
    </div>
  );
}

export default PaymentFailed;
